/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
export const DATE_FORMAT = 'MMM DD';

export const TIME_FORMAT = 'h:mm a z';

export const TIMESTAMP_FORMAT = TIME_FORMAT + ', ' + DATE_FORMAT;

export const TIMESTAMP_FORMAT_WITH_YEAR = TIMESTAMP_FORMAT + ' YYYY';
